module.exports = __webpack_public_path__ + "static/media/昨日殺神.9f0f8bd2.jpg";